<template>
    <div class="main_menu">
        <div class="cover pc" :style="`background-image: url(${banner});`"></div>
        <div class="cover mobile" :style="`background-image: url(${mobileBanner});`"></div>
        <div class="menu">
            <div class="container">
                <div class="menu_inner">
                    <div class="item" v-for="(item, index) in menu" :key="index">
                        <router-link :to="item.link" v-if="!item.hide">{{item.text}}</router-link>
                    </div>
                </div>
            </div>
        </div>
        <swiper ref="swiperMenu" class="menu_mobile" :options="menuOptions" @slideChangeTransitionEnd="slideChangeTransitionEnd">
            <template v-for="(item, index) in menu">
                <swiper-slide :key="index" v-if="!item.hide" :class="{active: activeIndex == index}">{{item.text}}</swiper-slide>
            </template>
        </swiper>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    name: "mainMenu",
    props: [ 'banner', 'menu', 'mobileBanner' ],
    data() {
        return {
            menuOptions: {
                slideToClickedSlide: true,
                slidesPerView: 'auto',
                centeredSlides: true,
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
            },
            activeIndex: 0,
        };
    },
    computed: {
        swiperMenu() {
            return this.$refs.swiperMenu.swiper
        },
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        menu: 'choosePath',
        $route: {
            handler: 'choosePath',
            immediate: true
        },
    },
    methods: {
        slideChangeTransitionEnd(){
            // this.$router.push(this.menu[this.swiperMenu.activeIndex].link)
            let index = this.swiperMenu.activeIndex;
            this.activeIndex = index;
            this.swiperMenu.slideTo(index);
            this.$router.push(this.menu[index].link)
        },
        choosePath(){
            for (let i = 0; i < this.menu.length; i++) {
                const item = this.menu[i];
                if(this.$route.path.indexOf(item.link) != -1 && !item.hide && item.link != ''){
                    this.$nextTick(()=>{
                        this.activeIndex = i;
                        this.swiperMenu.slideTo(i);
                    })
                    break;
                }
            }
        }
    },
};
</script>

<style scoped lang="scss">
.main_menu{
    position: relative;
    .cover{
        height: 5.35rem;
        background: no-repeat center/cover;
        &.mobile{
            display: none;
        }
    }
    .menu{
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        .menu_inner{
            display: flex;
            height: .8rem;
            background: rgba($color: #fff, $alpha: .7);
            border-radius: .04rem .04rem 0 0;
            .item{
                flex: 1;
                font-size: .26rem;
                a{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: .04rem .04rem 0 0;
                    &:hover,
                    &.active{
                        background: #fff;
                    }
                }
            }
        }
    }
    .menu_mobile{
        display: none;
    }
    @media only screen and (max-width: 1200px) {
        .cover{
            height: 13.5rem;
            &.pc{
                display: none;
            }
            &.mobile{
                display: block;
            }
        }
        .menu{
            display: none;
        }
        .menu_mobile{
            display: block;
            background: rgba($color: #fff, $alpha: .7);
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            .swiper-slide{
                width: auto;
                min-width: 5.6rem;
                padding: 0 1.8rem;
                height: 1.5rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: .72rem;
                border-radius: .04rem .04rem 0 0;
                transition: background-color .5s;
                &.active{
                    background: #fff;
                }
            }
        }
    }
}
</style>